"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isArrayBuffer(arg) {
    return (typeof ArrayBuffer === 'function' && arg instanceof ArrayBuffer)
        || Object.prototype.toString.call(arg) === '[object ArrayBuffer]';
}
exports.isArrayBuffer = isArrayBuffer;
//# sourceMappingURL=index.js.map